import { DatePipe, DecimalPipe, Location } from "@angular/common";
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { conformToMask } from "angular2-text-mask";
import { DateTime } from "luxon";
import {
  Observable,
  Subject,
  Subscription,
  concat,
  of,
  throwError,
} from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  flatMap,
  map,
  switchMap,
} from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { TicketCutoffTypeEnum } from "../../enum/cutoff-type.enum";
import { GroupsEnum } from "../../enum/groups.enum";
import { MenuConstants } from "../../infrastructure/MenuConstants";
import { Bank } from "../../model/domain/Bank";
import { CalendarModel } from "../../model/domain/CalendarModel";
import { Counterpart } from "../../model/domain/Counterpart";
import {
  DialogSize,
  FundType,
  OperationTypeQuota,
  Portfolio,
  SettlementType,
  TicketStatus,
  TicketType,
  WorkflowStatus,
} from "../../model/domain/Entity";
import { FundQuota } from "../../model/domain/FundQuota";
import { FundQuotaOperationValueUpdate } from "../../model/domain/FundQuotaOperationValueUpdate";
import { InvestedFund } from "../../model/domain/InvestedFund";
import { InvestedFundAccount } from "../../model/domain/InvestedFundAccount";
import { StockFundsPosition } from "../../model/domain/StockFundsModel";
import { NamedType } from "../../model/domain/Tipo";
import { AuthService } from "../../services/auth.service";
import { CalendarService } from "../../services/calendar.service";
import { CutoffService } from "../../services/cutoff.service";
import { DialogService } from "../../services/dialog.service";
import { DomainService } from "../../services/domain.service";
import { FileService } from "../../services/file.service";
import { LoaderService } from "../../services/loader.service";
import { SnackbarService } from "../../services/snackbar.service";
import { TicketService } from "../../services/ticket.service";
import { ValidatorService } from "../../services/validator.service";
import { AnnotationComponent } from "../annotation/annotation.component";
import { Roles } from "../auth/auth.role";
import { CounterpartComponent } from "../counterpart/counterpart.component";
import { TicketCutoffPermission } from "../cutoff/ticket-cutoff-type.model";
import { DadosFundoComponent } from "../dados-fundo/dados-fundo.component";
import { SerieEnum } from "./../../enum/series.enum";

@Component({
  selector: "app-cota",
  templateUrl: "./cota.component.html",
  styleUrls: ["./cota.component.css"],
})
export class CotaComponent implements OnInit, OnDestroy {
  faInfoCircle = faInfoCircle;
  public groups = GroupsEnum;

  constructor(
    public calendarService: CalendarService,
    private route: ActivatedRoute,
    private router: Router,
    private service: TicketService,
    public validator: ValidatorService,
    private datePipe: DatePipe,
    private snackBarService: SnackbarService,
    private cutoffService: CutoffService,
    private authService: AuthService,
    private dialogService: DialogService,
    private location: Location,
    private loaderService: LoaderService,
    private domainService: DomainService,
    private fileService: FileService
  ) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.resetForm();
      }
    });
  }

  @ViewChild("thisForm", { static: true }) public frm: NgForm;
  @ViewChild("portfolio", { static: true }) fundoComponent: DadosFundoComponent;
  @ViewChild("counterpart", { static: true })
  counterpartComponent: CounterpartComponent;
  @ViewChild("annotation", { static: true })
  annotationComponent: AnnotationComponent;

  @Output() dataChanged: EventEmitter<string> = new EventEmitter<string>();

  navigationSubscription: Subscription;

  OperationTypeQuota = OperationTypeQuota;
  TipoLiquidacao = SettlementType;
  TicketTypeEnum = TicketType;
  WorkFlowStatusEnum = WorkflowStatus;
  ListaTipoLiquidacao: NamedType<number>[];
  ListOperationTypesQuotas: NamedType<number>[];
  ListSettlementTypes: NamedType<number>[];
  ListQuotaNoFinancialOperationTypes: NamedType<number>[];

  isEditing = false;
  canValidate = false;
  sovereignActive = false;
  investedFundDocumentIsDisabled = false;
  investedFundNameIsDisabled = false;
  investedFundAccountIsDisabled = false;
  manualsettlementDateIsDisabled: boolean;

  // TODO: Aguardando definição Liquidação Clearing
  // commandIsDisabled: boolean;

  newFundIsDisabled = false;
  mnemonicCodeIsDisabled = false;
  quotationDateIsDisabled = true;
  operationValueIsDisabled: boolean;
  counterpartDisabled = false;
  tempSettlementDate: Date = null;

  model: FundQuota = null;
  banksList: Bank[] = null;
  investedFunds: InvestedFund[] = null;
  banksSettlementList: string[] = null;
  investedFundAccountList: InvestedFundAccount[] = null;
  selectedInvestedFundAccount: InvestedFundAccount = null;
  classEnum: NamedType<number>[];
  serieEnum: NamedType<number>[];
  selectedCounterpart: Counterpart = null;
  file: File;

  holidayList: CalendarModel[];

  numberMask: any;
  decimalPipe = new DecimalPipe("pt");

  // Invested Fund
  investedFundsByName: Observable<InvestedFund[]>;
  investedFundsByDocument: Observable<InvestedFund[]>;
  investedFundSearchNameTerm = new Subject<string>();
  investedFundSearchDocumentTerm = new Subject<string>();
  selectedInvestedFund: InvestedFund = new InvestedFund();

  // Custody Bank
  custodyBank: string = null;
  custodyBranch: string = null;
  custodyAccount: string = null;

  // Counterpart
  counterpartByName: Observable<Counterpart[]>;
  counterpartByDocument: Observable<Counterpart[]>;
  counterpartSearchNameTerm = new Subject<string>();
  counterpartSearchDocumentTerm = new Subject<string>();

  showEletronicTransferAction = false;
  isNotProduction = environment.name != "production";

  // TODO: utilizar um validador já existente, talvez uma diretiva do próprio angular
  validators = {
    // tslint:disable-next-line:max-line-length
    operationTypeId: (value) =>
      [
        OperationTypeQuota.Application,
        OperationTypeQuota.Redemption,
        OperationTypeQuota.FullRedemption,
        OperationTypeQuota.Amortization,
        OperationTypeQuota.Deposit,
        OperationTypeQuota.Withdrawal,
      ].includes(value),
    operationValue: (value) =>
      this.isCETIP() && this.isOperationValueRequired()
        ? this.coalesce(value) != "0,00"
        : true,
    operationValueTED: () =>
      this.isTED() && this.isOperationValueRequired()
        ? this.model.operationValue > 0
        : true,
    amount: (value) =>
      this.isAmountRequired() ? this.coalesce(value) > 0 : true,
    quotaValue: (value) =>
      this.isQuotaValueRequired() ? this.coalesce(value) > 0 : true,
    settlementTypeId: (value) =>
      [
        SettlementType.CETIP,
        SettlementType.TED,
        SettlementType.Sovereign,
        SettlementType.NoFinancial,
      ].includes(value),
    fundType: (value) => [FundType.CFF, FundType.CFA].includes(value),
    fundDocument: (value) =>
      this.model.isNewFund
        ? this.validator.validateDocument(value)
        : this.coalesce(value).length > 0,
    settlementDate: (value) =>
      this.coalesce(value).length > 0 &&
      DateTime.fromFormat(value, "dd/MM/yyyy").isValid,
    isManualsettlementDate: (value) =>
      !this.manualsettlementDateIsDisabled
        ? this.validateDate(this.model.settlementDate)
        : true,
    // this.coalesce(value).length === 0
    // || DateTime.fromFormat(value, 'dd/MM/yyyy',{zone:"UTC-GMT"}).isValid,
    quotationDate: (value) => true,
    // this.coalesce(value).length === 0 ||
    // DateTime.fromFormat(value, "dd/MM/yyyy",{zone:"UTC-GMT"}).isValid,
    fundName: (value) => this.coalesce(value).length > 0,
    subscriptionDate: (value) =>
      this.coalesce(value).length === 0 ||
      DateTime.fromFormat(value, "dd/MM/yyyy").isValid,
    fundClass: () => this.model.fundClass != null,
    fundSeries: () => this.model.fundSeries != null,
    fundSeriesQuantity: () =>
      !this.hasSerieQuantity() ||
      (this.model.fundSeriesQuantity != null &&
        this.model.fundSeriesQuantity > 1 &&
        this.hasSerieQuantity()),

    // TODO: Aguardando definição Liquidação Clearing
    // command: (value) =>
    //   !this.commandIsDisabled ? value >= 1500 && value <= 9999 : true,

    unitPrice: (value) =>
      this.coalesce(value).length === 0 ||
      conformToMask(value, this.validator.unitPriceMask, {}),
  };

  ngOnInit() {
    // this.dataChanged = new EventEmitter<string>();
    this.getBanksList();
    this.getListBanksSettlement();
    this.searchInvestedFunds();
    this.searchCounterpart();
    this.getTicket();
    this.getHolidayList();
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  resetForm() {
    this.model = new FundQuota();
    this.fundoComponent.portfolio = new Portfolio();
    this.counterpartComponent.counterpartModel = new Counterpart();
    this.selectedInvestedFund = new InvestedFund();
    this.investedFundAccountList = null;
    this.selectedInvestedFundAccount = null;

    this.frm.reset();
    this.frm.resetForm();

    this.fundoComponent.resetForm();
    this.counterpartComponent.resetForm();

    this.annotationComponent.annotation = null;

    this.isEditing = false;
    this.canValidate = false;
    this.model.id = 0;
    this.model.command = "0";
    this.model.isFIDC = false;
    this.model.isIssueUnitPrice = false;
    this.model.isNewFund = false;
    this.model.isNewCounterpart = false;
    this.model.isSecondaryMarket = null;

    this.model.operationDate = new Date();

    this.setEnable(true);
  }

  setEnable(enabled: boolean = false) {
    setTimeout(() => {
      if (enabled) {
        this.fundoComponent.setEnable(enabled);
        this.counterpartComponent.setEnable(enabled);
        Object.values(this.frm.controls).forEach((c) => {
          c.enable();
        });
        this.enableSelect();
      } else if (!this.canEdit()) {
        this.fundoComponent.setEnable(false);
        this.counterpartComponent.setEnable(false);
        this.annotationComponent.annotationIsDisabled = true;
        Object.values(this.frm.controls).forEach((c) => {
          if (c === this.frm.controls["operationValue"]) {
            if (!this.canEditSettlementDate()) {
              c.disable();
            }
          } else {
            c.disable();
          }
        });
        this.disableSelect();
      }
    }, 10);
  }

  disableSelect() {
    this.investedFundDocumentIsDisabled = true;
    this.investedFundNameIsDisabled = true;
    this.investedFundAccountIsDisabled = true;
    this.enableSelect();
    this.operationValueIsDisabled =
      this.containsGroup([this.groups.Controladoria]) &&
      this.model.statusId != WorkflowStatus.PendingControllershipApproval;
  }

  enableSelect() {
    this.manualsettlementDateIsDisabled =
      this.containsGroup([
        this.groups.AdmFiduci || this.groups.MiddleAdmFiduci,
      ]) && this.model.statusId != WorkflowStatus.PendingAdmApproval;

    // TODO: Aguardando definição Liquidação Clearing
    // this.commandIsDisabled =
    //   this.containsGroup([
    //     this.groups.Custodia || this.groups.ExternalClearing,
    //   ]) &&
    // this.model.statusId != WorkflowStatus.WaitingSettlementExternalClearing;
  }

  getTicket(idBoleta: number = null): void {
    this.model = new FundQuota();
    const id =
      idBoleta === null ? +this.route.snapshot.paramMap.get("id") : idBoleta;
    this.model.command = "0";
    this.model.id = id;

    this.classEnum = this.service.listClassEnum();
    this.serieEnum = this.service.listSerieEnum();

    this.ListQuotaNoFinancialOperationTypes =
      this.service.ListQuotaNoFinancialOperationTypes();

    this.service.FundQuota.getSovereignStatus().subscribe((b) => {
      this.sovereignActive = b;
      this.ListSettlementTypes = this.service.ListSettlementTypesQuotas(
        this.sovereignActive
      );

      this.ListOperationTypesQuotas = this.service.ListOperationTypesQuotas(
        this.model.settlementTypeId !== SettlementType.Sovereign
      );

      if (id === 0) {
        this.model.settlementTypeId = this.ListSettlementTypes[0].id;
        this.model.operationTypeId = this.ListOperationTypesQuotas[0].id;
      }
    });

    if (id) {
      this.service.FundQuota.getTicket(id).subscribe(
        (q) => {
          Object.assign(this.model, q);

          this.model.portfolioDocument = this.validator.formatDocument(
            this.model.portfolioDocument
          );

          if (this.model.isNewFund) {
            this.model.fundDocument = this.validator.formatDocument(
              this.model.fundDocument
            );
          } else {
            this.selectedInvestedFund.document = this.validator.formatDocument(
              this.model.fundDocument
            );
            this.selectedInvestedFund.name = this.model.fundName;
            this.selectedInvestedFund.administrator =
              this.model.fundAdministrator;
          }

          if (this.model.counterpartDocument) {
            this.model.counterpartDocument = this.validator.formatDocument(
              this.model.counterpartDocument
            );
          }

          if (this.isManualSettlementStep()) {
            this.model.settlementDate = null;
          }

          if (
            this.model.operationTypeId == OperationTypeQuota.FullRedemption &&
            this.model.statusId == WorkflowStatus.PendingControllershipApproval
          ) {
            this.model.operationValue = null;
          }

          if (
            this.model.counterpartDocument !== null &&
            this.model.fundDocument ===
              this.validator.sanitize(this.model.counterpartDocument) &&
            this.model.fundName === this.model.counterpartName
          ) {
            let investedFundAccount = {} as InvestedFundAccount;
            investedFundAccount.fundBank = this.model.fundBank;
            investedFundAccount.fundBranch = this.model.fundBranch;
            investedFundAccount.fundAccount = this.model.fundAccount;

            this.investedFundAccountList = [];
            this.investedFundAccountList.push(investedFundAccount);
            this.selectedInvestedFundAccount = this.investedFundAccountList[0];
            this.counterpartDisabled = true;
          }

          this.counterpartComponent.fillComponentFieldsLoad(this.model);

          this.fundoComponent.fillComponentFieldsLoad(this.model);

          if (this.isCETIP()) {
            this.model.operationValue = this.decimalPipe.transform(
              this.model.operationValue,
              "1.2-8",
              "pt-BR"
            ) as any;
          }

          this.model.settlementDate = this.datePipe.transform(
            this.model.settlementDate,
            "dd/MM/yyyy"
          ) as any;
          this.setSettlementDateBySecondaryMarket(true);
          this.model.quotationDate = this.datePipe.transform(
            this.model.quotationDate,
            "dd/MM/yyyy"
          ) as any;
          this.model.subscriptionDate = this.datePipe.transform(
            this.model.subscriptionDate,
            "dd/MM/yyyy"
          ) as any;

          // TODO: Aguardando definição Liquidação Clearing
          // this.model.unitPrice = this.decimalPipe.transform(
          //   this.model.unitPrice,
          //   "1.0-8",
          //   "pt-BR"
          // ) as any;

          this.isEditing = true;
          this.canValidate = true;

          this.dataChanged.emit();

          this.setEnable(false);
        },
        () => this.router.navigate([MenuConstants.Tickets.Quota])
      );
    } else {
      if (!this.model.statusId) {
        this.model.operationDate = new Date();
      }
    }
  }

  getBanksList() {
    this.domainService.ListBanks().subscribe((b) => {
      this.banksList = b;
    });
  }

  getListBanksSettlement() {
    this.service.getListBanksSettlement().subscribe((b) => {
      this.banksSettlementList = b;
    });
  }

  containsGroup(groups: GroupsEnum[]): boolean {
    return this.authService.hasGroup(groups);
  }

  // TODO: Aguardando definição Liquidação Clearing
  // commandDisabled() {
  //   return !this.containsGroup([
  //     this.groups.Custodia || this.groups.ExternalClearing,
  //   ]);
  // }

  searchCounterpart() {
    this.counterpartByName = concat(
      of([]),
      this.counterpartSearchNameTerm.pipe(
        filter((term) => term?.length >= 3),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap((name) =>
          this.service.getCounterpart(name, null).pipe(catchError(() => of([])))
        )
      )
    );

    this.counterpartByDocument = concat(
      of([]),
      this.counterpartSearchDocumentTerm.pipe(
        filter((term) => term?.length >= 3),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap((document) =>
          this.service
            .getCounterpart(null, document)
            .pipe(catchError(() => of([])))
        )
      )
    );
  }

  searchInvestedFunds() {
    this.investedFundsByName = concat(
      of([]),
      this.investedFundSearchNameTerm.pipe(
        filter((term) => term?.length >= 3),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap((name) =>
          this.service
            .getInvestedFunds(name, null)
            .pipe(catchError(() => of([])))
        )
      )
    );

    this.investedFundsByDocument = concat(
      of([]),
      this.investedFundSearchDocumentTerm.pipe(
        filter((term) => term?.length >= 3),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap((document) =>
          this.service
            .getInvestedFunds(null, document)
            .pipe(catchError(() => of([])))
        )
      )
    );
  }

  fillInvestedFundSelected(investedFund: InvestedFund = null) {
    if (investedFund) {
      this.selectedInvestedFund = investedFund;
    }

    this.model.fundName = null;
    this.model.fundAdministrator = null;
    this.model.fundDocument = null;
    this.model.mnemonicCode = null;
    this.model.isManualSettlementDate = null;

    // this.cleanOrFillCounterpart();

    this.selectedInvestedFundAccount = null;
    this.investedFundAccountList = null;

    if (this.selectedInvestedFund && this.selectedInvestedFund.document) {
      const fundDocument = this.validator.sanitize(
        this.selectedInvestedFund.document
      );
      this.model.fundDocument = this.selectedInvestedFund.document;
      this.service.FundQuota.getQuotationDate(
        fundDocument,
        this.model.operationTypeId
      ).subscribe((q) => {
        this.model.quotationDate = this.datePipe.transform(
          q,
          "dd/MM/yyyy"
        ) as any;
        const quotationDate = new Date(
          q.toString().replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
        );

        this.service.FundQuota.getSettlementDate(
          fundDocument,
          this.model.operationTypeId,
          quotationDate
        ).subscribe((s) => {
          this.model.settlementDate = this.datePipe.transform(
            s,
            "dd/MM/yyyy"
          ) as any;

          this.setSettlementDateBySecondaryMarket(true);
        });
      });

      this.model.fundName = this.selectedInvestedFund.name;
      this.model.fundAdministrator = this.selectedInvestedFund.administrator;
      this.model.fundDocument = this.selectedInvestedFund.document =
        this.validator.formatDocument(this.selectedInvestedFund.document);
      this.model.mnemonicCode = this.selectedInvestedFund.mnemonicCode;
      this.model.isFIDC = this.selectedInvestedFund.isFIDC;
      this.model.isManualSettlementDate =
        this.selectedInvestedFund.isManualSettlementDate;
      this.model.scheme = this.selectedInvestedFund.scheme;
      this.model.fundType =
        this.model.scheme == "1" ? FundType.CFF : FundType.CFA;
      this.model.allowEmptyAccount =
        this.selectedInvestedFund.allowEmptyAccount;

      if (this.selectedInvestedFund.isFIDC) {
        this.model.fundClass = this.selectedInvestedFund.fundClass;
      }

      if (this.selectedInvestedFund) {
        this.service
          .getInvestedFundAccounts(this.selectedInvestedFund.sourceId)
          .subscribe((res) => {
            this.investedFundAccountList = res.filter((item) => item.fundBank);

            if (this.investedFundAccountList.length === 1) {
              this.banksList = null;
              this.model.fundBank = this.investedFundAccountList[0].fundBank;
              this.model.fundBranch =
                this.investedFundAccountList[0].fundBranch;
              this.model.fundAccount =
                this.investedFundAccountList[0].fundAccount;
              this.selectedInvestedFundAccount =
                this.investedFundAccountList[0];
              this.model.counterpartDocument =
                this.selectedInvestedFund.document;
              this.model.counterpartName = this.selectedInvestedFund.name;
              this.model.isNewCounterpart = false;
              this.counterpartDisabled = true;
            }
          });
      }
    }
  }

  submit(): void {
    this.loaderService.addLoader();

    if (this.canEditSettlementDate()) {
      this.updateOperationValue();
    } else {
      const editing = this.isEditing;

      this.register(this.frm)
        .pipe(
          catchError((err) => {
            this.loaderService.removeLoader();

            this.snackBarService.open(err, "OK", {
              verticalPosition: "top",
              horizontalPosition: "right",
            });
            return throwError(err);
          })
        )
        .subscribe(
          (r) => {
            this.loaderService.removeLoader();

            const msg = editing ? "Boleta alterada." : "Boleta cadastrada.";

            this.snackBarService.open(msg, "OK", {
              verticalPosition: "top",
              horizontalPosition: "right",
            });
          },
          () => {}
        );
    }
  }

  register(f: NgForm, duplicate: boolean = false): Observable<FundQuota> {
    const editing = this.isEditing;

    if (!this.canEdit() && !this.canEditSettlementDate() && !duplicate) {
      return;
    }

    Object.values(f.controls).forEach((c) => {
      c.markAsTouched();
      c.updateValueAndValidity();
    });

    this.canValidate = true;

    const errors = this.getErrors();

    this.fundoComponent.validatePortfolioFields();
    const fundErrors = this.fundoComponent.getErrors();
    const counterpartErrors = this.counterpartComponent.getErrors();
    //to do fazer para o counterpart

    if (f.invalid || errors.length > 0) {
      return throwError("Verifique os campos destacados.");
    }

    if (fundErrors.length > 0) {
      return throwError("Verifique os campos nos dados do Fundo Investidor.");
    }

    if (counterpartErrors.length > 0 && !this.isCETIP) {
      return throwError("Verifique os campos nos dados da Contraparte.");
    }

    if (this.model.fundType.includes("CFF")) {
      var hasAttachment = false;

      if (
        this.model.id != 0 ||
        (this.model.id == 0 && this.model.tempTicketId != null)
      ) {
        this.fileService
          .getFilesPaginatedAttachment(
            this.model.tempTicketId,
            this.model.id,
            1,
            10
          )
          .subscribe((files) => {
            hasAttachment = files != null && files.rowCount > 0;

            if (!hasAttachment) {
              return throwError(
                "Para Cota de Fundo Fechado, é necessário incluir o boletim."
              );
            }
          });
      }
    }

    let data = Object.assign({}, this.model);

    // TODO: Aguardando definição Liquidação Clearing
    // data.unitPrice = this.validator.getCurrency(data.unitPrice);

    if (this.isCETIP()) {
      data.operationValue = this.validator.getCurrency(data.operationValue);
    }

    if (data.counterpartName == null || data.counterpartDocument == null) {
      data.counterpartName = data.fundName;
      data.counterpartDocument = data.fundDocument;
    }

    if (data.settlementTypeId === SettlementType.CETIP) {
      data.isCetipVoice = data.isCetipVoice || false;
      data.hasSameOwnership = false;

      if (data.counterpartDocument !== null) {
        data.counterpartDocument = this.validator.sanitize(
          data.counterpartDocument
        );
      }
    }

    if (this.isCETIPVoiceFixed()) {
      data.isCetipVoice = true;
    } else {
      data.isCetipVoice = false;
    }

    if (this.isTED()) {
      data.hasSameOwnership = data.hasSameOwnership || false;
      data.isCetipVoice = false;

      if (!this.hasCounterpart()) {
        data.counterpartName = null;
        data.counterpartDocument = null;
      } else {
        if (data.counterpartDocument !== null) {
          data.counterpartDocument = this.validator.sanitize(
            data.counterpartDocument
          );
        }
      }
      data.counterpartCetipAccount = null;
      data.command = "0";
      data.portfolioCetipAccount = null;
    }

    if (!data.isNewFund) {
      data.issuerName = null;
    }

    if (!data.isCetipVoice) {
      data.cetipVoiceId = null;
    }

    if (!this.isNoFinancial() && data.isSecondaryMarket === null) {
      data.isSecondaryMarket = false;
    }
    data.operationDate = null;
    data.statusId = null;
    data.id = null;

    if (duplicate) {
      data.workflowStartDate = null;
      data.workflowEndDate = null;
    }

    if (data.settlementDate != null) {
      data.settlementDate = new Date(
        data.settlementDate
          .toString()
          .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
      );
      this.setSettlementDateBySecondaryMarket(true);
    }

    if (data.quotationDate != null) {
      data.quotationDate = new Date(
        data.quotationDate
          .toString()
          .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
      );
    }

    if (data.subscriptionDate != null) {
      data.subscriptionDate = new Date(
        data.subscriptionDate
          .toString()
          .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
      );
    }

    data = this.fundoComponent.fillPortfolioData(
      data,
      this.fundoComponent.portfolio
    );

    data = this.counterpartComponent.fillCounterpartData(
      data,
      this.counterpartComponent.counterpartModel
    );

    if (
      data.settlementTypeId == SettlementType.TED &&
      !data.allowEmptyAccount &&
      (!data.fundBank || !data.fundAccount || !data.fundBranch)
    ) {
      return throwError(
        "Os dados bancários do Fundo Investido ou da Contraparte devem ser preenchidos completamente."
      );
    }

    if (
      this.model.isNewFund ||
      this.model.operationTypeId !== OperationTypeQuota.Application
    ) {
      data.fundDocument = this.validator.sanitize(data.fundDocument);

      if (data.counterpartDocument) {
        data.counterpartDocument = this.validator.sanitize(
          data.counterpartDocument
        );
      }
    } else {
      data.fundDocument = this.validator.sanitize(
        this.selectedInvestedFund.document
      );
      data.fundName = this.selectedInvestedFund.name;
    }

    data.annotations = this.annotationComponent.annotation;

    if (data.isNewFund) data.isManualSettlementDate = false;

    const method =
      editing && !duplicate
        ? this.service.FundQuota.updateTicket(this.model.id, data)
        : this.service.FundQuota.registerTicket(data);

    return method
      .pipe(
        catchError((err) => {
          var error = err.error;
          if (
            error.includes("duplicada") ||
            error.includes("duplicado") ||
            error.includes("não encontrado")
          ) {
            return throwError(error);
          }
          return throwError("Erro ao cadastrar a boleta.");
        })
      )
      .pipe(
        map((fund: FundQuota) => {
          if (!editing) {
            this.model.id = fund.id;
            this.model.operationDate = fund.operationDate;
            this.model.statusId = fund.statusId;
            this.model.accountManagerName = fund.accountManagerName;
            this.model.accountManagerDocument = fund.accountManagerDocument;
            this.model.accountManagerId = fund.accountManagerId;
            this.model.portfolioFundId = fund.portfolioFundId;
            this.model.settlementDate = this.datePipe.transform(
              fund.settlementDate,
              "dd/MM/yyyy"
            ) as any;
            this.setSettlementDateBySecondaryMarket(true);
            this.model.quotationDate = this.datePipe.transform(
              fund.quotationDate,
              "dd/MM/yyyy"
            ) as any;
            this.model.subscriptionDate = this.datePipe.transform(
              fund.subscriptionDate,
              "dd/MM/yyyy"
            ) as any;
            this.model.ticketCutoffTypeId = fund.ticketCutoffTypeId;

            this.isEditing = true;

            const url = this.router.createUrlTree([this.model.id], {
              relativeTo: this.route,
            });
            this.location.go(url.toString());
          }

          return this.model;
        })
      );
  }

  confirmForward(): Promise<boolean> {
    if (!this.canEdit()) {
      return Promise.resolve(false);
    }

    var textConfirm = "A boleta não poderá mais ser editada, deseja continuar?";

    if (this.isNotProduction) {
      textConfirm +=
        "<br />ATENÇÃO: ESTE É UM AMBIENTE DE TESTE. NÃO EXECUTE OPERAÇÕES REAIS.";
    }

    return this.dialogService
      .confirm("Encaminhar Boleta", textConfirm)
      .toPromise()
      .then((result) => {
        if (!result) {
          return false;
        }

        const mensagem =
          "É necessário enviar a ordem desta operação para a Contraparte (Fundo Investido), \
      com a confirmação que será convertida, para que seja processada corretamente.<br /><br />\
      O não atendimento do procedimento acima poderá acarretar em cancelamento da operação e/ou atraso na \
      divulgação da cota do Fundo.";

        return this.dialogService
          .confirm("Alerta", mensagem, "OK", "Cancelar", DialogSize.Medium)
          .toPromise()
          .then((dialogResult) => {
            if (!dialogResult) {
              return false;
            }
            const operationDate = DateTime.fromJSDate(
              new Date(this.model.operationDate.toString())
            );

            if (operationDate.day < DateTime.local().day) {
              return this.dialogService
                .confirm(
                  "Boleta Retroativa",
                  "A data de operação da boleta será alterada para a data de hoje.",
                  "OK",
                  "Cancelar"
                )
                .toPromise();
            }

            return true;
          });
      });
  }

  async forward(): Promise<void> {
    const cutoffPermission = await this.checkPermission();

    if (!cutoffPermission.isAllowed) {
      this.snackBarService.open(
        this.cutoffService.warningMessage +
          this.cutoffService.dateTimeOffsetToTimeString(
            cutoffPermission.timeLimit
          ),
        "OK"
      );
      return;
    }

    this.confirmForward().then((ok) => {
      if (!ok) {
        return;
      }
      this.register(this.frm)
        .pipe(
          catchError((err) => {
            this.snackBarService.open(err, "OK", {
              verticalPosition: "top",
              horizontalPosition: "right",
            });
            return throwError(err);
          })
        )
        .subscribe(
          (fund: FundQuota) => {
            this.service.FundQuota.forwardTicket(fund.id).subscribe((res) => {
              this.model.statusDescription = res.statusDescription;

              Object.values(this.frm.controls).forEach((c) => {
                c.disable();
              });

              this.snackBarService.open("Boleta encaminhada.", "OK", {
                verticalPosition: "top",
                horizontalPosition: "right",
              });

              this.getTicket(fund.id);
            });
          },
          () => {}
        );
    });
  }

  cancel() {
    return this.dialogService
      .confirm("Cancelar Boleta", "Deseja cancelar esta boleta?")
      .pipe(
        flatMap((ok) => {
          if (ok) {
            return this.service.FundQuota.cancelDraftTicket(this.model.id);
          }

          return of(null);
        })
      )
      .subscribe((res) => {
        if (res) {
          this.model.statusDescription = res.statusDescription;

          Object.values(this.frm.controls).forEach((c) => {
            c.disable();
          });

          this.snackBarService.open("Boleta cancelada.", "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });

          this.getTicket(this.model.id);
        }
      });
  }

  approve(): void {
    if (this.hasErrorElectronicTransfer()) {
      this.dialogService
        .confirm(
          "Aprovar Boleta",
          "ATENÇÃO: O status da Transferência TED/TEF nesta boleta está com erro. Isto significa que a transferência não aconteceu e a liquidação deve ser feita de forma manual. Deseja aprovar a boleta mesmo assim?",
          "Aprovar mesmo assim",
          "Cancelar",
          DialogSize.Medium
        )
        .subscribe((result) => {
          if (result) {
            this.ticketApprove(this.frm);
          }
        });
    } else {
      this.dialogService
        .confirm("Aprovar Boleta", "Deseja aprovar esta boleta?")
        .subscribe((result) => {
          if (result) {
            this.ticketApprove(this.frm);
          }
        });
    }
  }

  private ticketApprove(f: NgForm) {
    const errors = this.getErrors();

    Object.values(f.controls).forEach((c) => {
      c.markAsTouched();
      c.updateValueAndValidity();
    });

    if (f.invalid || errors.length > 0) {
      this.snackBarService.open("Verifique os campos destacados.", "OK", {
        verticalPosition: "top",
        horizontalPosition: "right",
      });
    } else {
      this.ticketUpdateAdmFiduci();
      // TODO: Aguardando definição Liquidação Clearing
      // this.ticketUpdateCommand();
      this.ticketUpdateControllerShip();
      this.service.approve(this.model.id, "").subscribe(() => {
        this.snackBarService.open("Boleta atualizada com sucesso.");

        this.getTicket(this.model.id);
      });
    }
  }

  private ticketUpdateAdmFiduci() {
    if (
      this.isManualSettlementStep() &&
      this.containsGroup([this.groups.AdmFiduci || this.groups.MiddleAdmFiduci])
    ) {
      this.model.settlementDate = new Date(
        this.model.settlementDate
          .toString()
          .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
      );
      this.setSettlementDateBySecondaryMarket(true);

      const data: FundQuota = new FundQuota();
      data.settlementDate = this.model.settlementDate;
      data.administratorAnnotation = this.model.administratorAnnotation;
      this.service.FundQuota.updateSettlementDate(
        this.model.id,
        data
      ).subscribe(() => {});
    }
  }

  private updateOperationValue() {
    this.model.portfolioDocument = this.model.portfolioDocument.replace(
      /\D/g,
      ""
    );

    var fundQuotaOperationValue = new FundQuotaOperationValueUpdate();

    fundQuotaOperationValue.operationValue = this.model.operationValue;

    this.service.FundQuota.updateOperationValue(
      this.model.id,
      fundQuotaOperationValue
    ).subscribe(() => {
      this.loaderService.removeLoader();
    });
  }

  // TODO: Aguardando definição Liquidação Clearing
  // private ticketUpdateCommand() {
  //   if (
  //     this.model.statusId == WorkflowStatus.WaitingSettlementExternalClearing &&
  //     this.containsGroup([this.groups.ExternalClearing])
  //   ) {
  //     const data: FundQuota = new FundQuota();
  //     data.command = this.model.command;
  //     this.service.FundQuota.updateCommand(
  //       this.model.id,
  //       data.command
  //     ).subscribe(() => {});
  //   }
  // }

  private ticketUpdateControllerShip() {
    if (
      this.model.operationTypeId == OperationTypeQuota.FullRedemption &&
      this.containsGroup([this.groups.Controladoria])
    ) {
      this.model.settlementDate = new Date(
        this.model.settlementDate
          .toString()
          .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
      );
      this.setSettlementDateBySecondaryMarket(true);
      this.model.quotationDate = new Date(
        this.model.quotationDate
          .toString()
          .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
      );
      this.model.portfolioDocument = this.model.portfolioDocument.replace(
        /\D/g,
        ""
      );
      this.updateOperationValue();
    }
  }

  getHolidayList() {
    this.calendarService.getHolidaysList().subscribe((res) => {
      res.forEach((x) => {
        x.date = this.datePipe.transform(x.date, "dd/MM/yyyy", "UTC") as any;
      });
      this.holidayList = res;
    });
  }

  validateDate(date: Date) {
    if (date != null) {
      if (this.holidayList.length > 0) {
        this.holidayList.forEach((x) => {
          if (date == x.date) {
            return false;
          }
        });
      }
      date = new Date(
        date.toString().replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
      );
      var yesterdayDate = new Date();
      yesterdayDate.setDate(yesterdayDate.getDate() - 1);

      if (
        date.getDate() < yesterdayDate.getDate() ||
        date.getDay() == 0 ||
        date.getDay() == 6
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  reject(): void {
    this.dialogService
      .reject("Reprovar Boleta", "Deseja reprovar esta boleta?")
      .subscribe((result) => {
        if (result) {
          this.ticketCancel(result.justification);
        }
      });
  }

  private ticketCancel(justification: string) {
    this.service.reject(this.model.id, justification).subscribe(() => {
      this.snackBarService.open("Boleta atualizada com sucesso.");
      this.getTicket(this.model.id);
    });
  }

  duplicate() {
    this.register(this.frm, true)
      .pipe(
        catchError((err) => {
          this.loaderService.removeLoader();

          this.snackBarService.open(err, "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });
          return throwError(err);
        })
      )
      .subscribe((newTicket) => {
        this.snackBarService
          .open("Boleta duplicada.", "Visualizar no Monitor", {
            verticalPosition: "top",
            horizontalPosition: "right",
            duration: 6000,
          })
          .onAction()
          .subscribe((a) => {
            this.router.navigate([
              MenuConstants.Todos,
              { ticketId: TicketType.Quota },
            ]);
          });
      });
  }

  coalesce(value: any) {
    return value || "";
  }

  hasError(prop: string): boolean {
    if (!this.canValidate) {
      return false;
    }

    return !this.validators[prop](this.model[prop]);
  }

  getErrors(): string[] {
    const validationErrors = [];

    Object.keys(this.validators).forEach((k) => {
      if (!this.validators[k](this.model[k])) {
        validationErrors.push(k);
      }
    });

    return validationErrors;
  }

  isRedemption(): boolean {
    return this.model.operationTypeId === OperationTypeQuota.Redemption;
  }

  isApplication(): boolean {
    return this.model.operationTypeId === OperationTypeQuota.Application;
  }

  isCETIP(): boolean {
    return this.model.settlementTypeId === SettlementType.CETIP;
  }

  isNoFinancial(): boolean {
    return this.model.settlementTypeId === SettlementType.NoFinancial;
  }

  isFullRedemption(): boolean {
    return this.model.operationTypeId == OperationTypeQuota.FullRedemption;
  }

  hasCounterpart(): boolean {
    return (
      this.isCETIP() ||
      (this.isTED() && !this.model.hasSameOwnership) ||
      this.isNoFinancial()
    );
  }

  isCETIPVoiceFixed(): boolean {
    return false; //this.model.isSecondaryMarket && this.isCETIP() && (this.model.fundType === FundType.CFF);
  }

  isTED(): boolean {
    return (
      this.model.settlementTypeId === SettlementType.TED ||
      this.model.settlementTypeId === SettlementType.Sovereign
    );
  }

  isOperationValueRequired() {
    let isRequired =
      this.model.settlementTypeId !== SettlementType.NoFinancial &&
      this.model.operationTypeId != OperationTypeQuota.FullRedemption;

    return isRequired;
  }

  isQuotaValueRequired(): boolean {
    //return (this.model.isSecondaryMarket && !this.model.isIssueUnitPrice) || (!this.model.isSecondaryMarket && this.model.isIssueUnitPrice);

    return this.model.isSecondaryMarket;
  }

  isAmountRequired() {
    //return this.model.operationTypeId === OperationTypeQuota.FullRedemption;
    let isRequired = false;

    if (
      this.model.settlementTypeId !== SettlementType.NoFinancial &&
      this.model.isSecondaryMarket == true &&
      this.model.operationTypeId != OperationTypeQuota.FullRedemption
    ) {
      isRequired = true;
    }

    return isRequired;
  }

  isManualSettlementStep() {
    return (
      this.model.isManualSettlementDate &&
      this.model.statusId == WorkflowStatus.PendingAdmApproval
    );
  }

  valueIsEmpty(value: any) {
    return value === null || value === 0 || value.toString() == "";
  }

  canEdit(): boolean {
    var canEdit =
      !this.model.statusId &&
      !this.model.statusDescription &&
      this.authService.hasRole(Roles.CreateTicketFundQuota);

    return canEdit;
  }

  async checkPermission(): Promise<TicketCutoffPermission> {
    let cutoffTypeId = this.model.ticketCutoffTypeId;
    let accountManagerId = this.model.accountManagerId;
    let fundId = this.model.portfolioFundId;

    if (accountManagerId === null) {
      switch (this.model.settlementTypeId) {
        case SettlementType.CETIP:
        case SettlementType.NoFinancial:
          cutoffTypeId = TicketCutoffTypeEnum.QuotasCetip;
          break;
        case SettlementType.TED:
          cutoffTypeId = TicketCutoffTypeEnum.QuotasTed;
          break;
        case SettlementType.Sovereign:
          cutoffTypeId = TicketCutoffTypeEnum.QuotasSovereign;
          break;
      }

      accountManagerId = this.authService.authToken.accountManagerId;
      fundId = this.fundoComponent.portfolio.fundId;
    }

    return this.cutoffService.isAvailable(
      cutoffTypeId,
      this.model.id,
      accountManagerId,
      fundId
    );
  }

  canDuplicate(): boolean {
    const _operationDate = this.datePipe.transform(
      this.model.operationDate,
      "yyyy-MM-dd"
    );
    const _duplicateTicketDateLimit = this.datePipe.transform(
      new Date(environment.duplicateTicketDateLimit),
      "yyyy-MM-dd"
    );

    return (
      this.model.id &&
      this.authService.hasRole(Roles.CreateTicketFundQuota) &&
      !(_operationDate <= _duplicateTicketDateLimit)
    );
  }

  canChangeStatus(): boolean {
    return (
      this.model.statusId &&
      this.authService.hasRoles(this.model.statusRequiredRoles)
    );
  }

  canCancel() {
    return (
      this.model.id &&
      (!this.model.statusId || this.model.statusId === TicketStatus.Draft) &&
      this.authService.hasRole(Roles.CreateTicketFundQuota)
    );
  }

  cleanClassSeries() {
    this.model.fundClass = null;
  }

  cleanInvestedFunds() {
    this.model.fundName = null;
    this.model.fundAdministrator = null;
    this.model.fundDocument = null;
    this.model.quotationDate = null;
    this.model.settlementDate = null;
    this.model.subscriptionDate = null;
    this.model.fundBank = null;
    this.model.fundBranch = null;
    this.model.fundAccount = null;
    this.investedFundAccountList = null;

    if (
      this.model.settlementTypeId &&
      this.model.settlementTypeId !== SettlementType.Sovereign
    ) {
      this.selectedInvestedFund = new InvestedFund();
      this.investedFundDocumentIsDisabled = false;
      this.investedFundNameIsDisabled = false;
      this.newFundIsDisabled = false;
      this.mnemonicCodeIsDisabled = false;
    }

    if (!this.isEditing) {
      this.model.issuerName = null;
      this.model.isFIDC = false;
      this.model.fundClass = null;
      this.model.fundType = FundType.CFF;
      this.model.quotationDate = null;
      this.model.settlementDate = null;
      this.model.subscriptionDate = null;

      this.model.mnemonicCode = null;
    }

    if (this.model.isNewFund) {
      this.quotationDateIsDisabled = false;
      this.manualsettlementDateIsDisabled = false;
    } else {
      this.quotationDateIsDisabled = true;
      this.manualsettlementDateIsDisabled = true;
    }
  }

  getSovereign() {
    this.ListOperationTypesQuotas = this.service.ListOperationTypesQuotas(
      this.model.settlementTypeId !== SettlementType.Sovereign
    );

    this.cleanInvestedFunds();

    if (this.model.settlementTypeId === this.TipoLiquidacao.Sovereign) {
      this.service.getInvestedFundSovereign().subscribe((q) => {
        this.fillInvestedFundSelected(q);
        this.investedFundDocumentIsDisabled = true;
        this.investedFundNameIsDisabled = true;
        this.newFundIsDisabled = true;
        this.mnemonicCodeIsDisabled = true;
        this.fundoComponent.settlementType = this.model.settlementTypeId;
      });
    } else {
      this.model.fundType = FundType.CFF;
      this.investedFundDocumentIsDisabled = false;
      this.investedFundNameIsDisabled = false;
      this.newFundIsDisabled = false;
      this.model.isNewCounterpart = true;
      this.counterpartDisabled = false;
      this.investedFundAccountList = null;
      this.mnemonicCodeIsDisabled = false;
      this.model.counterpartDocument = null;
      this.model.counterpartName = null;
    }
  }

  isOutCustody(): boolean {
    if (
      this.fundoComponent.portfolio.bank === null ||
      this.banksSettlementList === null ||
      this.banksSettlementList.includes(this.fundoComponent.portfolio.bank)
    ) {
      return false;
    } else {
      return true;
    }
  }

  /**
   * @description Check if can send tranfer for liquidation
   * @returns true if workflow status is awaiting Shipping / Receiving of Matera Transfer
   */
  canSendTransferForLiquidation(): boolean {
    return (
      this.model.statusId === 10 &&
      this.authService.hasRole(Roles.ApprovePendingSettlementMiddle)
    );
  }

  /**
   * @description Check if can check status of Matera Tranfer
   * @returns true if workflow status is on transfer liquidation
   */
  canCheckStatusTransfer(): boolean {
    return (
      this.model.statusId === 11 &&
      this.authService.hasRole(Roles.ApproveActiveSettlementMiddle)
    );
  }

  isFundClosed(): boolean {
    return this.model.scheme === "1";
  }

  /**
   * @description Transfer ETA - Electronic Transfer Available (TED - Transferência Eletrônica Disponível) to Matera API
   */
  electronicTransferAvailable(): void {}

  checkEletronicTransferAction(): void {
    this.service.checkEletronicTransferTicket(this.model.id).subscribe(
      () => {
        this.showEletronicTransferAction = true;
      },
      () => {
        this.showEletronicTransferAction = false;
      }
    );
  }

  checkEletronicTransferSituation(): void {
    this.service.getEletronicTransferSituationTicket(this.model.id).subscribe(
      (result) => {
        this.snackBarService.open(`Status: ${result.status.description}`);
      },
      (err) => {
        this.snackBarService.open(`Erro: ${err.error.message}`);
      }
    );
  }

  disableActionButtons() {
    let disabled =
      this.model.transferStatusDescription == "Transferência em Trânsito" ||
      this.model.transferStatusDescription == "Transferência Pendente" ||
      this.model.transferStatusDescription == "Transferência Agendada";

    return disabled;
  }

  enableCancelTransactionButton() {
    return this.model.transferStatusDescription == "Transferência Agendada";
  }

  hasErrorElectronicTransfer() {
    return this.model.transferStatusDescription == "Transferência com Erro";
  }

  setTempId(tempId) {
    this.model.tempTicketId = tempId;
  }

  setTempSettlementDate(settlementDate: Date) {
    this.model.settlementDate = settlementDate;
  }

  setTempAdministratorAnnotation(annotation: string) {
    this.model.administratorAnnotation = annotation;
  }

  fillComponentWhenInvestedFundAccountSelected() {
    this.model.fundBank = null;
    this.model.fundBranch = null;
    this.model.fundAccount = null;
    this.model.counterpartDocument = null;
    this.model.counterpartName = null;

    if (
      (this.model.isSecondaryMarket && !this.isNoFinancial()) ||
      (this.isTED() && this.investedFundAccountList.length > 0)
    ) {
      this.model.fundBank = this.selectedInvestedFundAccount.fundBank;
      this.model.fundBranch = this.selectedInvestedFundAccount.fundBranch;
      this.model.fundAccount = this.selectedInvestedFundAccount.fundAccount;
      this.model.counterpartDocument = this.selectedInvestedFund.document;
      this.model.counterpartName = this.selectedInvestedFund.name;
      this.counterpartDisabled = true;
      this.model.isNewCounterpart = false;
    }

    if (this.isNoFinancial()) {
      this.model.fundBank = this.selectedInvestedFundAccount.fundBank;
      this.model.fundBranch = this.selectedInvestedFundAccount.fundBranch;
      this.model.fundAccount = this.selectedInvestedFundAccount.fundAccount;
    }
  }

  cleanOrFillCounterpart() {
    if (this.model.isNewCounterpart || this.model.isNewFund) {
      this.model.fundBank = null;
      this.model.fundBranch = null;
      this.model.fundAccount = null;
      this.model.counterpartDocument = null;
      this.model.counterpartName = null;
    } else {
      this.fillComponentWhenInvestedFundAccountSelected();
    }
  }

  calculateQuotaValue() {
    if (
      this.model.isSecondaryMarket &&
      this.model.operationValue != null &&
      this.model.amount != null
    ) {
      this.model.quotaValue =
        this.validator.getCurrency(this.model.operationValue) /
        this.model.amount;
    }
  }

  calculateAmountValue() {
    if (
      this.model.isSecondaryMarket &&
      this.model.operationValue != null &&
      this.model.quotaValue != null
    ) {
      this.model.amount =
        this.validator.getCurrency(this.model.operationValue) /
        this.model.quotaValue;
    }
  }

  // TODO: Aguardando definição Liquidação Clearing
  // calculateOperationValue() {
  //   if (this.isCETIP()) {
  //     if (this.model.amount != 0 || this.model.unitPrice != 0) {
  //       const amount = this.validator.getCurrency(this.model.amount);
  //       const unitPrice = this.validator.getCurrency(this.model.unitPrice);
  //       const operationValue = amount * unitPrice;
  //       this.model.operationValue = this.transformDecimal(operationValue);
  //     }
  //     return this.validator.getCurrency(this.model.operationValue);
  //   }
  // }

  checkQuotaAndAmountValues() {
    if (
      this.model.isSecondaryMarket &&
      (this.model.amount != null || this.model.quotaValue != null)
    ) {
      this.calculateQuotaValue();
    }
  }

  transformDecimal(val: number): number {
    return this.decimalPipe.transform(val, "1.2-8", "pt-BR") as any;
  }

  hasSerieQuantity(): boolean {
    let serie: NamedType<number> = this.serieEnum.filter(
      (x) => x.id == SerieEnum.Unique
    )[0];
    return (
      !(this.model.fundSeries == serie.name) && this.model.fundSeries != null
    );
  }

  cleanSerieQuantity() {
    if (!this.hasSerieQuantity()) {
      this.model.fundSeriesQuantity = null;
    }
  }

  getStockSelectedFund(selectedFund: StockFundsPosition) {
    if (this.isFullRedemption()) {
      this.model.operationValue = selectedFund.netValue;
      this.model.amount = selectedFund.availableQuantity;
      this.model.quotaValue = selectedFund.quotaValue;
    }

    if (selectedFund.fundSourceId)
      this.service
        .getInvestedFunds(null, null, null, selectedFund.fundSourceId)
        .subscribe((res) => {
          this.fillInvestedFundSelected(res[0]);
        });
  }

  setSettlementDateBySecondaryMarket(saveSettlementDate: boolean = false) {
    if (this.model.isSecondaryMarket) {
      this.tempSettlementDate = this.model.settlementDate;
    } else if (!saveSettlementDate) {
      this.model.settlementDate = this.tempSettlementDate;
    } else {
      this.tempSettlementDate = this.model.settlementDate;
    }
  }

  showTransferStatus() {
    return (
      this.model.id != null &&
      this.model.id != 0 &&
      this.model.transferStatusDescription != null &&
      this.model.transferStatusDescription != ""
    );
  }

  canEditSettlementDate(): boolean {
    var canEdit =
      this.containsGroup([this.groups.Controladoria, this.groups.Custodia]) &&
      this.model.statusId == WorkflowStatus.WaitingSettlementExternalClearing;

    return canEdit;
  }
}
